import { PoliticsPerformanceCategory } from '../../enums/politics-performance-category.enum';

export const POLITICS_PERFORMANCE_CATEGORY_BY_MARKET: Record<string, PoliticsPerformanceCategory> =
	{};

export const POLITICS_PERFORMANCE_CATEGORY_BY_SEEDED_CATEGORY: Record<
	string,
	PoliticsPerformanceCategory
> = {
	Midterms: PoliticsPerformanceCategory.Midterms,
	'Senate Elections': PoliticsPerformanceCategory.SenateElections,
	'House Elections': PoliticsPerformanceCategory.HouseElections,
	'Governor Elections': PoliticsPerformanceCategory.GovernorElections,
};
